import { supabase } from '../supabaseClient';

/* Accès aux données « create-user ». Chaque fonction renvoie la requête Supabase telle quelle
   (à attendre par l'appelant) : aucune logique métier ici. */

export function createUserAccount(fullName, newUserForm) {
  return supabase.functions.invoke('create-user', {
    body: { email: newUserForm.email, nom: fullName, role: newUserForm.role },
  });
}
